'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var BazaarVoiceInline = function BazaarVoiceInline(props) {
  return _react2.default.createElement('div', {
    className: 'rating-inline ' + props.className
  }, _react2.default.createElement('div', {
    id: 'BVRRInlineRating-' + props.slug
  }));
};
BazaarVoiceInline.defaultProps = {
  className: ''
};
BazaarVoiceInline.propTypes = {
  className: _propTypes2.default.string,
  slug: _propTypes2.default.string.isRequired
};
exports.default = BazaarVoiceInline;